import { render } from "./FileTree.vue?vue&type=template&id=6481e34d"
import script from "./FileTree.vue?vue&type=script&lang=js"
export * from "./FileTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__